<template>
  <div class="mb-4">

    <!--#region -- Content ---->

    <div class="stage-header border-bottom mb-4">
      <!--#region Header-->
      <div class="caption-label">FTIE Ticket Basic Information</div>
      <div class="row mb-4">
        <div class="col-4">
          <div class="header-col">
            <div>Unique compo P/N</div>
            <div>
              {{ _.get(compoPnDetailInfo, 'unique_compo_pn', '') }}
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>QVL Link</div>
            <div><a class="link" target="_blank" :href="qvl_link"> QVL Link</a></div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>MOQ</div>
            <div>{{ _.get(compoPnDetailInfo, 'moq', '')}}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Inventory Qty</div>
            <div>{{ _.get(compoPnDetailInfo, 'inventory_qty', '') }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>PR Qty</div>
            <div>{{ _.get(compoPnDetailInfo, 'pr_qty_total', '') }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>PO Qty</div>
            <div>{{ _.get(compoPnDetailInfo, 'po_qty_total', '') }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Total So Qty</div>
            <div>{{ total_so_qty}}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Total Mps Qty</div>
            <div>{{total_mps_qty}}</div>
          </div>
        </div>
        <div class="col-4">
        </div>
        <div class="col-12">
          <div class="header-col">
            <div>P/N desc</div>
            <div>
              {{ _.get(compoPnDetailInfo, 'unique_compo_pn_description', '') }}
            </div>
          </div>
        </div>
      </div>



    </div>
    <div class="stage-header border-bottom mb-4">
      <div class="label" style="padding-left: 33px;">
        <br>
        Inventory of Unique Component
        <!--<div class="d-flex">
          <div v-if="compoPnDetailInfo !== null && _.get(compoPnDetailInfo, 'inventory_info_list', null) != null" class="h5 font-weight-bold">
            {{ compoPnDetailInfo.inventory_info_list.length }} Results
            <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-download"
                    v-b-tooltip.hover title="Download Inventory Report"
                    @click="reportDownload()"></button>
          </div>
          <div v-else class="h5 font-weight-bold">
            {{ compoPnDetailInfo.inventory_info_list.length }} Results
          </div>
        </div>-->
        <b-table v-if="compoPnDetailInfo.inventory_info_list!=null" small thead-class="thead-light text-dark"
                 :items="compoPnDetailInfo.inventory_info_list" :fields="fields">
        </b-table>
      </div>
    </div>


  </div>
</template>

<script>
  import { faL } from '@fortawesome/free-solid-svg-icons';
  /* END EXTERNAL SOURCE */
  /* BEGIN EXTERNAL SOURCE */

  import * as moment from 'moment/moment';
  export default {
    name: 'gtc-ftie-page',
    props: {
      prop_ftie_page_obj: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_user_roles: {
        default: null
      },
    },
    data: function () {
      return {

        ticketWithUniqueInfo: null,
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        fields: [
          { key: 'shipping_pn', label: 'Shipping P/N', thClass: 'align-middle ', thStyle: { width: '10%' }, sortable: true },
          { key: 'shipping_pn_desc', label: 'Shipping P/N Description', thClass: 'align-middle', thStyle: { width: '20%' }, sortable: false },
          { key: 'closed_order', label: 'Closed Order', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: true },
          { key: 'order', label: 'Order', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: true },
          { key: 'mps', label: 'MPS', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: true },
          //{ key: 'potential', label: 'Potential', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: false },
          { key: 'ftie_id_list', label: 'FTIE_ID', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: false },
        ],
        inMailGroup: false,
        ticket_owner_options: [],
        login_user_name: null,
        userSites: null,
        userRoles: null,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        temp_gtc_owner: '',
        ticketOpen: true,
        compoPnDetailInfo: null
      }
    },
    computed: {
      total_so_qty() {
        let self = this;
        return _.sumBy(self.compoPnDetailInfo.inventory_info_list, 'order');
      },
      total_mps_qty() {
        let self = this;
        return _.sumBy(self.compoPnDetailInfo.inventory_info_list, 'mps');
      },
      qvl_link() {
        let self = this;
        let pn = _.get(self.compoPnDetailInfo, 'unique_compo_pn', '')
        if(pn){
          return `http://qvl.getac.com.tw/Index/Index.aspx?PartNo=${pn}&Type=1`;
        }
        return '';
      }
    },
    created() {
      let self = this;
      self.checkLoggedIn();
      let access_flag = self.inventoryReportAccess();
      if (access_flag == false) {
        self.$router.push('/home');
      }
    },
    mounted() {
      let self = this;
      let access_flag = self.inventoryReportAccess();
      if (access_flag == false) {
        self.$router.push('/home');
      } else {
        self.getInventoryByFtie()
      }
    },
    watch: {

    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
        //return 'DEV' !== this.$session.get('mode');
      },

      getInventoryByFtie() {
        let self = this;
        let url = self.$root.baseUrl + '/inventory-management/unique_component/detail/';
        let request_data = {
          compo_pn: self.$route.params.pn
        };
        console.log("request_data:");
        console.log(request_data);
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let compoPnDetailInfoRes = null;
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              compoPnDetailInfoRes = JSON.parse(res['compo_pn_detail_info']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.compoPnDetailInfo = compoPnDetailInfoRes;
            eventHub.$emit('loading', false);
          })

      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;

      },

      getOwnerList() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/get-ftie-owners';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let gtc_owner_list = [];
        let gro_owner_list = [];
        self.$axios.get(url, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              gtc_owner_list = JSON.parse(res['gtc_owner_list']);
              gro_owner_list = JSON.parse(res['gro_owner_list']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.ticket_owner_options = gtc_owner_list;
          });
      },

      getFtiePage(ftie_id) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/page-with-chatroom/';
        let request_data = {
          ftie_id: ftie_id
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let ftie_page_obj = null;
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              ftie_page_obj = JSON.parse(res['ftie_page_obj']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.ftie_page_obj = ftie_page_obj;
            if (_.get(self.ftie_page_obj, 'status', '') === 'Close') {
              self.ticketOpen = false;
            } else {
              self.ticketOpen = true;
            }
            eventHub.$emit('loading', false);
          })
      },

      getSfProductline() {
        let self = this;

        let requestData = {
          create_by: self.ftie_page_obj.gtc_owner,
          username: self.login_user_name,
          ftie_id: self.ftie_page_obj.ftie_id,
          detail_id: self.ftie_page_obj.request_detail_id
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/nre/customization-nre-pn/', requestData)
          .then(res => {
            let result = res.data;
            result.basic_info = JSON.parse(result.basic_info);

            if (_.get(result, 'sku_pn_info_list_for_nre', null) !== null &&
              _.size(_.get(result, 'sku_pn_info_list_for_nre', new Array())) > 0) {
              result.sku_pn_info_list_for_nre = JSON.parse(result.sku_pn_info_list_for_nre);
            }

            if (_.get(result, 'ref_sku_info_list', null) !== null &&
              _.size(_.get(result, 'ref_sku_info_list', new Array())) > 0) {
              result.ref_sku_info_list = JSON.parse(result.ref_sku_info_list);
            }

            if (_.get(result, 'sfdc_line_info_list', null) !== null &&
              _.size(_.get(result, 'sfdc_line_info_list', new Array())) > 0) {
              result.sfdc_line_info_list = JSON.parse(result.sfdc_line_info_list);
            }

            console.log("result.sku_pn_info_list_for_nre::");
            console.log(result.sku_pn_info_list_for_nre);
            console.log("result.ref_sku_info_list::");
            console.log(result.ref_sku_info_list);
            console.log("result.basic_info::");
            console.log(result.basic_info);
            console.log("result.sfdc_line_info_list::");
            console.log(result.sfdc_line_info_list);

            self.basicInfo = result.basic_info;
            self.sfdcProducts = result.sfdc_line_info_list

          })
          .finally(() => {
            console.log("COMPLETE /nre/customization-nre-pn/");
            //if (realSkuForNreRefresh !== null && realSkuForNreRefresh !== '') {
            //  self.refreshNreQuotes(realSkuForNreRefresh);
            //}
            //self.searching = false;
            //self.resetAddOrCloneNreModalData(true);
            //self.actionEnable = self.checkActionEnable();
            eventHub.$emit('loading', false);
          });

      },
      getSfEsOptyInfo() {
        let self = this;

        let requestData = {
          es_id: self.ft.salesforce_es_id,
          opty_id: self.ftie_page_obj.salesforce_opty_id
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/ftie/get-sf-info/', requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'es_main_es_info', null) !== null) {
              self.es_main_es_info = JSON.parse(result.es_main_es_info);
            }

            if (_.get(result, 'sf_es_info', null) !== null) {
              self.sf_es_info = JSON.parse(result.sf_es_info);
            }

            if (_.get(result, 'sf_opty_info', null) !== null) {
              self.sf_opty_info = JSON.parse(result.sf_opty_info);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            console.log("Befreo prop self.es_main_es_info:");
            console.log(self.es_main_es_info);
          });

      }, reportDownload() {
        let self = this;
        let url = self.$root.baseUrl + '/inventory-management/unique_component/ftie/inventory_download/';
        console.log('####inventory management - download######');

        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();
        let request_data = {
          download_dict: self.ticketWithUniqueInfo.inventory_info_list,
          downloadTime: downloadTime,
          ftie_id: self.ticketWithUniqueInfo.ftie_id
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = self.ticketWithUniqueInfo.ftie_id + '_inventory_report_.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      inventoryReportAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        if ((user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1) || (user_roles && _.indexOf(user_roles, 'ES_PM') > -1)
          || (user_roles && _.indexOf(user_roles, 'HQ_ES') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1) || (user_roles && _.indexOf(user_roles, 'HQ_Sales') > -1)
          || (user_functions && _.indexOf(user_functions, 'Getac Sales Manager') > -1) || (user_functions && _.indexOf(user_functions, 'GRO TOP Manager') > -1)
        ) {
          console.log("Access to inventory report!");
          return true
        }
        return false;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/unique-compo-inventory/ComponentInventoryPage.vue